import { render } from "./WithIcons.vue?vue&type=template&id=01f45f90&bindings={\"changeTab\":\"options\"}"
import script from "./WithIcons.vue?vue&type=script&lang=js"
export * from "./WithIcons.vue?vue&type=script&lang=js"
script.render = render

export default script